import useMediaQuery from "@mui/material/useMediaQuery";
import { mediaQueryDown, mediaQueryUp } from "../styles/breakpoints";

export const useBreakpoint = () => {
  const isWideDesktop = useMediaQuery(mediaQueryUp("xl"));
  const isDesktop = useMediaQuery(mediaQueryUp("lg"));
  const isMobile = useMediaQuery(mediaQueryDown("md"));

  return {
    isWideDesktop,
    isDesktop,
    isMobile,
    isTablet: !isDesktop && !isMobile,
  };
};
